export enum OpenModal {
  MANAGEDOMAINS = "manageDomains",
}
